/**
 * FeedbackPresentationMode
 */
export enum FeedbackPresentationMode {
    ONE_BY_ONE = 'one_by_one',
    CARDS = 'cards',
    SINGLE_FORM = 'single_form'
}
